import React, { useEffect, useState } from "react";
import { getEquitySummary } from "../services/api.js";

export default function EquityWidget({ period='month' }){
  const [summary, setSummary] = useState({ current_equity:0, change:0, change_percent:0 });

  useEffect(()=>{ (async()=>{ setSummary(await getEquitySummary(period)); })(); },[period]);
  const up = (summary.change_percent||0) >= 0;

  return (
    <div className="card">
      <div className="text-sm opacity-70">Equity Zusammenfassung ({period})</div>
      <div className="text-3xl font-semibold">{(summary.current_equity||0).toFixed(2)} €</div>
      <div className={`text-sm ${up?'text-green-600':'text-red-600'}`}>
        {up?'▲':'▼'} {(Math.abs(summary.change_percent||0)).toFixed(2)}% ({(summary.change||0).toFixed(2)} €)
      </div>
    </div>
  );
}